import { render } from "./PbxDashboardSelector.vue?vue&type=template&id=c1e8edc0"
import script from "./PbxDashboardSelector.vue?vue&type=script&lang=js"
export * from "./PbxDashboardSelector.vue?vue&type=script&lang=js"

import "./PbxDashboardSelector.vue?vue&type=style&index=0&id=c1e8edc0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__